import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { AppStore } from '../../store/applicationState';
import { GetCerteficate, UpdateCerteficate } from '../../store/certeficate/actions';
import { CheckUser } from '../../store/users/actions';
import { Button } from '../../test/components/ui';
import { ChangeFio } from '../modals';
import { IconCry } from '../svgs/IconCry';
import { Loader } from '../ui/Loader';
import * as Styles from './styles';

interface Props {}

export const Certificate: React.FC<Props> = () => {
  const [isEdit, setIsEdit] = React.useState(false);
  const [isModal, setIsModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const { Sockets, Users, Certeficate } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (Sockets.event) {
      dispatch(GetCerteficate.request({ data: { event_id: Sockets.event.absnum } }));
    }
  }, [dispatch, Sockets.event]);

  const generateCertificate = () => {
    if (!Sockets.event || !Users.user) return null;
    let fio_ua = Users.user.fio;
    if (!isEdit && Certeficate.data?.entity?.fio_ua && Users.user.fio.length < Certeficate.data.entity.fio_ua.length) {
      fio_ua = Certeficate.data.entity.fio_ua;
    }
    setLoading(true);
    dispatch(
      UpdateCerteficate.request({
        data: {
          event_id: Sockets.event.absnum,
          fio_ua,
        },
        callBack: (succ, data) => {
          if (succ && data.cert_pdf && data.message === 'ok') {
            window.open(data.cert_pdf);
          }
          setLoading(false);
          if (Sockets.event) {
            dispatch(
              GetCerteficate.request({
                data: { event_id: Sockets.event.absnum },
              })
            );
          }
        },
      })
    );
  };

  if (Certeficate.error)
    return (
      <Styles.ModalBodyS>
        <h4 style={{ textAlign: 'center' }}>{Certeficate.error}</h4>
      </Styles.ModalBodyS>
    );

  if (!Sockets.event || !Certeficate.data) return null;

  if (new Date(new Date(Sockets.event.dateEnd).getTime() + 3 * 24 * 60 * 60 * 1000) > new Date())
    return (
      <Styles.ModalBodyS>
        <h4>Вітаю! Персональний сертифікат, що підтверджує участь у події буде доступний Вам на 3 робочий день після закінчення заходу!</h4>
      </Styles.ModalBodyS>
    );
  if (!Certeficate.data.entity)
    return (
      <Styles.ModalBodyS>
        <WrapText>
          Прикро <IconCry />
          <br /> Сталась помилка. Ваш сертифікат не знайдено в Єдиному реєстрі документів про підвищення кваліфікації Експертус. Зверніться, будь
          ласка, в підтримку за номером 0800 21 38 38
        </WrapText>
      </Styles.ModalBodyS>
    );
  if (Certeficate.data.entity.cert_pdf && Number(Certeficate.data.entity.is_change) > 0)
    return (
      <Styles.ModalBodyS style={{ textAlign: 'center' }}>
        <h4>Сертифікат можете скачати за даним посиланням</h4>
        <a href={Certeficate.data.entity.cert_pdf} target="_blank" rel="noreferrer" style={{ color: '-webkit-link', textDecoration: 'underline' }}>
          {Certeficate.data.entity.cert_pdf}
        </a>
      </Styles.ModalBodyS>
    );
  return (
    <>
      <Styles.ModalBodyS>
        <h4 style={{ textAlign: 'center' }}>Перевірте правильність написання Вашого імені, саме так буде вказано в сертифікаті.</h4>
        <h2 style={{ textAlign: 'center' }}>{Users.user?.fio} </h2>
      </Styles.ModalBodyS>
      <Styles.ModalFooterS>
        <WrapBtn>
          <Button onClick={() => setIsModal(true)} title="Є помилка" />
          <Button onClick={generateCertificate} title="Все вірно" />
        </WrapBtn>
      </Styles.ModalFooterS>
      {loading && <Loader />}
      {isModal && (
        <ChangeFio
          changeHandler={() => setIsEdit(true)}
          closeHandler={() => {
            setIsModal(false);
            Sockets.event && dispatch(CheckUser.request({ data: { event_id: Sockets.event.absnum } }));
          }}
        />
      )}
    </>
  );
};

const WrapBtn = styled.div`
  display: flex;
  justify-content: center;
  & > * {
    &:nth-child(1) {
      margin-right: 50px;
    }
  }
`;

const WrapText = styled.h4`
  img {
    width: 50px;
    height: auto;
  }
`;
